<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-section">
        <h3>{{ footerInfo.company_name || '康泰药业' }}</h3>
        <p>专注医药健康，呵护全家安康</p>
        <div class="contact-info">
          <p><i class="icon-phone"></i> 联系电话：{{ footerInfo.contact_phone || '加载中...' }}</p>
          <p><i class="icon-email"></i> 电子邮箱：{{ footerInfo.contact_email || '加载中...' }}</p>
          <p><i class="icon-address"></i> 公司地址：{{ footerInfo.company_address || '加载中...' }}</p>
        </div>
      </div>

      <div class="footer-section">
        <h3>快速链接</h3>
        <ul class="footer-links">
          <li><router-link :to="{ name: 'Home' }">首页</router-link></li>
          <li><router-link :to="{ name: 'Products' }">产品中心</router-link></li>
          <li><router-link :to="{ name: 'About' }">关于我们</router-link></li>
          <li><router-link :to="{ name: 'Articles' }">推荐文章</router-link></li>
          <li><a href="" @click.prevent="handleQualityAnnouncement">质量公告</a></li>
        </ul>
      </div>

      <div class="footer-section">
        <h3>产品分类</h3>
        <ul class="footer-links">
          <li v-if="categoryLoading">加载分类中...</li>
          <li v-else-if="categoryError">加载分类失败</li>
          <li v-else-if="categories.length === 0">暂无分类数据</li>
          <li v-else v-for="category in categories" :key="category.id">
            <router-link :to="{ name: 'Products', query: { category: category.id } }">
              {{ category.name }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <div class="copyright">
      <p>© {{ new Date().getFullYear() }} {{ footerInfo.site_name || '康泰药业' }} 版权所有 |
        <a href="https://beian.miit.gov.cn/" target="_blank" class="icp-link">
          {{ footerInfo.icp_number || '京ICP备123456号' }}
        </a>
             |
        <a href="https://nxhmjk-icons.oss-cn-beijing.aliyuncs.com/8824770a5bc27fad3c99abf74e3fc3e7.png" target="_blank" class="icp-link">
          (京)网药械信息备字(2025)第00321号
        </a>
        |
        <a href="https://nxhmjk-icons.oss-cn-beijing.aliyuncs.com/5760d8e299726275c97afdc1531445eb.png" target="_blank" class="icp-link">
           (京)网药平台备字(2025)第000026号
        </a>
        |
        <a href="https://scjgj.beijing.gov.cn/cxfw/" target="_blank" class="icp-link">
          (京)市监网食备20250014621
        </a>
        |
        <a href="https://app.gjzwfw.gov.cn/jmopen/webapp/html5/Zyyszcry/index.html" target="_blank" class="icp-link">
          执业药师注册证编号:111625050711
        </a>
        |
        <a href="https://nxhmjk-icons.oss-cn-beijing.aliyuncs.com/healthservices/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20260413103543_117_24.png" target="_blank" class="icp-link">
          电信业务许可证编号:京B2-20250125
        </a>
        |
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=11010502058815" target="_blank" class="icp-link iconDis">
          <img src="@/assets/gongan-icon.png" alt="">(京)公网安备11010502058815号
        </a>
      </p>
    </div>
    <el-dialog
      v-model="dialogVisible"
      title="质量公告"
      width="600"
      :before-close="handleClose"
    >
      <div v-if="announcements && announcements.length">
        <ul class="announcement-list">
          <li v-for="item in announcements" :key="item.id">
            <a :href="item.href" target="_blank" rel="noopener noreferrer">
              {{ item.name }}
            </a>
          </li>
        </ul>
      </div>
      <div v-else>
        暂无质量公告信息
      </div>
    </el-dialog>
  </footer>
</template>

<script>
import { getMedicineCategories, getFooterInfo } from '@/api/config'
import { announcements } from '@/config/notice'
export default {
  name: 'TheFooter',
  data() {
    return {
      categories: [],
      categoryLoading: false,
      categoryError: null,
      footerInfo: {
        site_name: '',
        icp_number: '',
        company_name: '',
        company_address: '',
        contact_phone: '',
        contact_email: ''
      },
      footerLoading: false,
      footerError: null,
      dialogVisible: false
    }
  },
  created() {
    this.loadCategories()
    this.loadFooterInfo()
  },
  computed:{
    announcements(){
      return announcements
    }
  },
  methods: {
    async loadCategories() {
      this.categoryLoading = true
      this.categoryError = null

      try {
        const response = await getMedicineCategories()

        if (response.code === 1) {
          this.categories = response.data.sort((a, b) => b.weigh - a.weigh)
        } else {
          this.categoryError = response.msg || '获取分类数据失败'
          console.error('获取分类失败:', this.categoryError)
        }
      } catch (error) {
        console.error('获取分类数据错误:', error)
        this.categoryError = '网络错误，请稍后重试'
      } finally {
        this.categoryLoading = false
      }
    },

    async loadFooterInfo() {
      this.footerLoading = true
      this.footerError = null

      try {
        const response = await getFooterInfo()

        if (response.code === 1) {
          this.footerInfo = response.data
        } else {
          this.footerError = response.msg || '获取底部信息失败'
          console.error('获取底部信息失败:', this.footerError)
        }
      } catch (error) {
        console.error('获取底部信息错误:', error)
        this.footerError = '网络错误，请稍后重试'
      } finally {
        this.footerLoading = false
      }
    },
    handleQualityAnnouncement() {
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
/* 底部信息组件样式 */
.footer {
  background-color: #2c3e50;
  color: #ccc;
  padding: 60px 20px 20px;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.footer-section h3 {
  color: white;
  margin-bottom: 20px;
  font-size: 1.3rem;
}

.contact-info p {
  margin-bottom: 10px;
  display: flex;
  align-items: flex-start;
}

.contact-info i {
  min-width: 20px;
  margin-right: 8px;
  text-align: center;
}

.footer-links {
  list-style-type: none;
}

.footer-links li {
  margin-bottom: 10px;
}

.footer-links a {
  color: #ccc;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-links a:hover {
  color: white;
}

.qr-code {
  text-align: center;
}

.qr-code img {
  width: 120px;
  height: 120px;
  background-color: white;
  padding: 5px;
  border-radius: 4px;
  margin-bottom: 8px;
}

.copyright {
  max-width: 1200px;
  margin: 40px auto 0;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
  font-size: 0.9rem;
  color: #999;
}

.icp-link {
  color: #999;
  text-decoration: none;
  transition: color 0.3s;
}

.icp-link:hover {
  color: #fff;
  text-decoration: underline;
}

.announcement-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.announcement-list li {
  margin-bottom: 8px;
}

.announcement-list a {
  color: #409eff;
  text-decoration: none;
  word-break: break-all;
}

.announcement-list a:hover {
  text-decoration: underline;
}

@media (max-width: 576px) {
  .footer-container {
    grid-template-columns: 1fr;
  }

  .footer-section {
    margin-bottom: 30px;
  }
}
.iconDis{

  display: inline-flex;
  align-items: center;
  img{
    width: 15px;
    object-fit: cover;
    margin-right: 5px;
  }
}
</style>
